import { fetchAsObservable } from 'fetcher!sofe';
import { pluck } from 'rxjs/operators';

export function fetchEntities() {
  return fetchAsObservable(`/wg/entities?role=TeamMember`).pipe(pluck('users'));
}

export function getSelectUser(user_exchange_id) {
  const body = {
    grant_type: "user_exchange",
    user_exchange_id,
  };

  return fetchAsObservable(`/token`, {
    passThrough401: true,
    method: 'post',
    headers: {
      'Authorization': 'Basic ' + btoa('TaxUI:f7fsf29adsy9fg')
    },
    body,
  })
}
